import { render, staticRenderFns } from "./footer.html?vue&type=template&id=316de5bf&scoped=true&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=316de5bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316de5bf",
  null
  
)

export default component.exports